import { TournamentData } from "./TournamentData";
import { getSelectedYear } from "../../../context/YearContext";

export class TournamentLink {
  constructor() {
    this.tournament = {
      round16: [],
      round8: [],
      round4: [],
      round3: [],
      round2: [],
    };
  }

  async request(gender, distance, year = getSelectedYear()) {
    try {
      const response = await fetch(process.env.REACT_APP_API_BASE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          "bk-working": "tournament",
          gender: gender.toUpperCase(),
          distance: distance,
          year: year,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      this.receiveJSON(result);
      return this;
    } catch (error) {
      console.error("TournamentLink request failed:", error);
      throw error;
    }
  }

  receiveJSON(resultData) {
    const tournamentData = resultData?.tournament || {};

    // 각 라운드 데이터 매핑
    const rounds = ["round16", "round8", "round4", "round3", "round2"];
    // 선수가 없는 조는 응답에 빠지므로 조 번호 자리(jo_number - 1)에 배치
    rounds.forEach((round) => {
      const roundArray = tournamentData[round] || [];
      const matches = [];
      roundArray.forEach((item) => {
        matches[item.jo_number - 1] = TournamentData.fromJson(item);
      });
      this.tournament[round] = matches;
    });

    return true;
  }
}
